
const initialState = {
    sidebarShow: true,
}

const SidebarReducer = (state = initialState, { type, ...rest }) => {
    switch (type) {
        case 'set':
            return { ...state, ...rest }
        default:
            return state
    }
}


export default SidebarReducer